import React from 'react';
import { Box } from '@mui/material';

interface DrawerContentProps {
  children: React.ReactNode;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        p: 3,
        pb: 0,
      }}
    >
      {children}
    </Box>
  );
};
